import { flowRight } from 'lodash/fp';
import { withProps } from 'recompose';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import baseDataForm from 'components/dataForm';
import { countErrors } from 'common/formValidation/lib';
import formValidate from './formValidate';

const dataForm = ({ form, ...options }) => flowRight([
    // override the validate props
    connect(null, { change }),
    withProps(({ change: updateField }) => ({
        // inform the form name
        form,
        // override the validate method
        validate: (values, props) => {
            // validate the form
            const errors = formValidate(values, props);

            // count the errors (excluding the global _error which is a string)
            updateField(form, 'errorCount', countErrors(errors, ['_error']));

            return errors;
        },
    })),
    // initialize the original data form
    baseDataForm(options),
]);

export default dataForm;
